import axios from 'axios';

// Configuração base da API (mesmo padrão de utils/api.js)
const API_BASE_URL = process.env.NODE_ENV === 'production'
  ? '/api/v1'
  : (process.env.REACT_APP_API_URL || 'http://localhost:3001/api/v1');

// Instância do axios dedicada ao painel admin.
// withCredentials é essencial: é o que faz o navegador enviar/receber o
// cookie httpOnly de sessão nas requisições.
const adminApi = axios.create({
  baseURL: `${API_BASE_URL}/admin`,
  timeout: 30000,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

adminApi.interceptors.request.use(
  (config) => {
    if (process.env.NODE_ENV === 'development') {
      console.log(`🔐 Admin API Request: ${config.method?.toUpperCase()} ${config.url}`);
    }
    return config;
  },
  (error) => Promise.reject(error)
);

adminApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      const { status, data } = error.response;

      switch (status) {
        case 401:
          error.userMessage = 'Sessão expirada. Faça login novamente.';
          break;
        case 429:
          error.userMessage = 'Muitas tentativas. Aguarde alguns minutos.';
          break;
        case 500:
          error.userMessage = 'Erro interno do servidor. Tente novamente.';
          break;
        default:
          error.userMessage = data?.error || 'Erro desconhecido';
      }
    } else if (error.request) {
      error.userMessage = 'Erro de conexão. Verifique sua internet.';
    } else {
      error.userMessage = 'Erro interno da aplicação';
    }

    return Promise.reject(error);
  }
);

export const authAPI = {
  async login(email, password) {
    const response = await adminApi.post('/auth/login', { email, password });
    return response.data;
  },

  async logout() {
    const response = await adminApi.post('/auth/logout');
    return response.data;
  },

  async me() {
    const response = await adminApi.get('/auth/me');
    return response.data;
  },
};

export default adminApi;
